import {
  RECORD_WXINFO,
  GET_WXINFO
} from './mutation-types'
import {setStore, getStore} from '../utils/storage'
export default {
  // 记录微信用户信息
  [RECORD_WXINFO] (state, info) {
    state.wxInfo = info
    setStore('wxInfo', info)
  },
  // 获取微信用户信息
  [GET_WXINFO] (state) {
    let wxInfo = getStore('wxInfo')
    if (wxInfo) {
      state.wxInfo = JSON.parse(wxInfo)
    } else {
      state.wxInfo = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js